export enum SystemStatusSubSystem {
  BLACKPOINT = 'Blackpoint',
  EXCHANGE = 'Exchange',
  PLANNING = 'Planning',
  ACCESS = 'AccessRights',
  HANGFIRE = 'HangfireStatus',
  STARTUP = 'StartUp',
}
